module.exports = __webpack_public_path__ + "assets/img/29_405_big.0391eac6.jpg";